<template>
  <multiple_form
    :forms="forms"
    :edit="props.isEdit"
    :editData="props.editData"
    :disabled="props.disabled"
    :itemCol="24"
    @submit="handelSubmit"
    submitText="审批"
    ref="formRef"
  />
</template>
<script setup>
  import { defineProps, defineEmits, computed, ref } from 'vue'
  import { message } from 'ant-design-vue'
  import { approval } from '@/api/black_white_list/car_list_approval'
  import multiple_form from '@/components/multiple_form'
  import { blackWhiteListType, resultOptions } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
    disabled: { type: Boolean, default: false },
  })
  const emit = defineEmits(['submit'])
  const formRef = ref()

  //编辑、新增的表单
  const forms = computed(() => [
    {
      id: 'car_list',
      itemWidth: '420px',
      formItem: [
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
          dataInObject: 'carBlackWhiteList',
        },
        {
          type: 'select',
          field: 'type_id',
          label: '车型',
          storeOptions: 'carModel',
          dataInObject: 'carBlackWhiteList',
        },
        {
          type: 'select',
          field: 'type',
          options: constantToOptions(blackWhiteListType),
          label: '名单类型',
        },
        {
          type: 'dateRange',
          startField: 'start_time',
          endField: 'end_time',
          dataInObject: 'carBlackWhiteList',
          label: '有效时间',
        },
        {
          type: 'input',
          field: 'in_reason',
          dataInObject: 'carBlackWhiteList',
          label: '原因备注',
        },
        {
          type: 'radio',
          field: 'result',
          label: '审批结果',
          defaultValue: 1,
          options: constantToOptions(resultOptions),
          disabled: false,
          onChange: (val) => {
            if (
              formRef.value &&
              formRef.value.formRefs &&
              formRef.value.formRefs.car_list &&
              formRef.value.formRefs.car_list.formState
            ) {
              formRef.value.formRefs.car_list.formState.remark =
                // val.target.value === '1' ? '审批通过。' : '审批不通过。'
                val.target.value === '1' ? '审批通过。' : ''
            }
          },
        },
        {
          type: 'textarea',
          field: 'remark',
          label: '审批意见',
          defaultValue: '审批通过。',
          disabled: false,
        },
      ],
    },
  ])

  async function handelSubmit(data) {
    const messageText = '审核'
    const res = await approval({
      ...data,
      taskIds: props.editData[props.idField],
    })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }
</script>
